import React, { useContext, useState, useEffect } from 'react'
import styled from 'styled-components'
import LiveSelect from 'live/components/forms/ui/select'
import Breadcrumb, { BreadcrumbItem } from '../Breadcrumb'
import i18n from 'live/services/i18n'
import theme from 'live/services/theme'
import moment from 'moment'
import { getCarStatusStyle, getLastUpdated, navegateToPositionsReport, navegateToTripsReport } from '../../utils'
import TripsContext from '../../contexts/TripsContext'
import { DashboardContext } from 'live/context/dashboard'
import Skeleton from 'react-loading-skeleton'
import OptionsSelector from '../OptionsSelector/index'

interface IProps {
    name?: string
    plate?: string
    totalTrips?: number
    totalItineraries?: number
    totalSchedules: number
    status?: string
    time?: number
    isLoading: boolean
    keyMatch: string
    collection: string
    noData: boolean
}

const TOTAL_TRIPS = 1
const TOTAL_ITINERARIES = 2
const TOTAL_SCHEDULES = 3

const kindOfTotal = [
    { id: 1, title: 'Total Trips', icon: 'fas fa-car' },
    { id: 2, title: 'Itineraries', icon: 'fas fa-directions' },
    { id: 3, title: 'Schedules', icon: 'fas fa-calendar-alt' }
]

const TripsHeaderInformation = ({
    name = 'N/A',
    plate = 'N/A',
    totalTrips = 0,
    totalSchedules = 0,
    totalItineraries = 0,
    time,
    isLoading,
    status,
    collection,
    keyMatch,
    noData
}: IProps): JSX.Element => {
    const { setIsNavegateToTrips, setInfoWindow, positionsReportId, tripsReportId } = useContext(TripsContext)
    const [OptionsOpen, setOptionsOpen] = useState(false)

    const handleSetOptionsOpen = open => setOptionsOpen(open)

    const chooseKindOfTotal = id => {
        if (id === TOTAL_TRIPS) return totalTrips
        if (id === TOTAL_SCHEDULES) return totalSchedules
        if (id === TOTAL_ITINERARIES) return totalItineraries
    }

    const breadcrumItems: BreadcrumbItem[] = [
        {
            title: 'All Vehicles',
            onClick: () => {
                setInfoWindow(undefined)
                setIsNavegateToTrips(undefined)
                window.history.pushState({}, '', window.location.href.replace(/imei=([^&]*)/, ''))
            }
        },
        {
            title: 'Vehicle Trips'
        }
    ]

    return (
        <HeaderWrapper>
            <HeaderContainer>
                <Breadcrumb items={breadcrumItems}></Breadcrumb>
            </HeaderContainer>

            <HeaderContainer>
                <StyledUl>
                    <FlexStyleLi>
                        <div className="vehicle-info">
                            <i style={getCarStatusStyle(status)} className={`fas fa-circle status-car`}></i>
                            <span className="trips-header-title">{name}</span>
                            <span>{plate}</span>
                        </div>
                        {/*<OptionsSelector*/}
                        {/*    open={OptionsOpen}*/}
                        {/*    setOpen={handleSetOptionsOpen}*/}
                        {/*    options={[*/}
                        {/*        // positionsReportId > 0*/}
                        {/*        //     ? {*/}
                        {/*        //           label: i18n('View positions report'),*/}
                        {/*        //           icon: 'far fa-file-alt',*/}
                        {/*        //           action: () => navegateToPositionsReport(plate, positionsReportId),*/}
                        {/*        //           active: !noData*/}
                        {/*        //       }*/}
                        {/*        //     : null,*/}
                        {/*        tripsReportId > 0*/}
                        {/*            ? {*/}
                        {/*                  label: i18n('View trips report'),*/}
                        {/*                  icon: 'far fa-file-alt',*/}
                        {/*                  action: () => navegateToTripsReport(collection, keyMatch, tripsReportId),*/}
                        {/*                  active: !noData*/}
                        {/*              }*/}
                        {/*            : null*/}
                        {/*    ].filter(option => option !== null)}*/}
                        {/*/>*/}
                    </FlexStyleLi>

                    {/* TO-DO <StyleLi>
                        <span className="trips-header-time">{context?.params?.span}</span>
                    </StyleLi> */}
                </StyledUl>
            </HeaderContainer>

            <HeaderContainer>
                <StyledUl>
                    <StyleLi className="d-flex">
                        {kindOfTotal.map((result, index) => {
                            return (
                                <StyleKindOfTotal key={index} style={{ flex: 1 }}>
                                    <div className="wrapper-icon">
                                        <i className={result.icon}></i>
                                    </div>
                                    <div className="wrapper-content">
                                        <ul>
                                            <li className="result-title">{i18n(result.title)}</li>
                                            <li className="result-value">
                                                {isLoading ? <Skeleton width="60px" /> : chooseKindOfTotal(result.id)}
                                            </li>
                                        </ul>
                                    </div>
                                </StyleKindOfTotal>
                            )
                        })}
                    </StyleLi>

                    <StyleLi className="last-updated">
                        <i className="fas fa-history"></i>
                        <span>{getLastUpdated(time)}</span>
                    </StyleLi>
                </StyledUl>
            </HeaderContainer>
        </HeaderWrapper>
    )
}

export default React.memo(TripsHeaderInformation)

const HeaderWrapper = styled.div`
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06);
    border-radius: 2px 2px 0px 0px;
    min-height: 128px;
    z-index: 100;
    position: relative;
`

const HeaderContainer = styled.div`
    display: flex;
    margin-top: 16px;

    &:first-of-type {
        margin-top: 0;
    }
`

const StyledUl = styled.ul`
    display: flex;
    width: 100%;
    padding: 0;
    margin: 0;
    align-items: end;
`

const StyleLi = styled.li`
    & ~ .last-updated {
        text-align: end;
        font-size: 11px;
        color: ${({ theme }) => theme['gray-700']};
        i {
            margin-right: 4px;
        }
    }

    .trips-header-title {
        margin-left: 4px;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        color: ${({ theme }) => theme['gray-800']};

        &::after {
            content: '|';
            margin: 0 12px;
            font-weight: normal;
            color: ${({ theme }) => theme['gray-400']};
        }
    }

    .trips-header-time {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 16px;
        color: ${({ theme }) => theme['gray-600']};
        white-space: nowrap;
    }

    &:first-of-type {
        flex: 4;
    }
`
const FlexStyleLi = styled(StyleLi)`
    display: flex;
    justify-content: space-between;
    align-items: center;

    .vehicle-info {
        display: flex;
        align-items: center;
    }
`
const StyleKindOfTotal = styled.div`
    display: flex;

    .wrapper-icon {
        height: 32px;
        width: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: ${({ theme }) => theme['gray-600']};
        background: ${({ theme }) => theme['gray-200']};

        i {
            font-weight: 600;
        }
    }

    .wrapper-content {
        ul {
            padding: 0 7px;

            .result-title {
                font-size: 11px;
                text-transform: uppercase;
                font-weight: 600;
                color: ${({ theme }) => theme['gray-700']};
            }

            .result-value {
                font-size: 16px;
                font-weight: 600;
                color: ${({ theme }) => theme['gray-800']};
            }
        }
    }
`
